var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnHeaderNoAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30.7568C18.5002 31.151 18.591 31.5412 18.7669 31.9053C18.9429 32.2694 19.2006 32.6002 19.5255 32.8787C19.8505 33.1573 20.2361 33.3782 20.6606 33.5289C21.085 33.6796 21.5399 33.757 21.9992 33.7568C22.9267 33.7565 23.816 33.4404 24.4723 32.878C25.1286 32.3156 25.4983 31.5528 25.5 30.7568",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.2568C26.8325 10.2568 30.75 14.1743 30.75 19.0068V26.1494L31.124 26.3662L31.6582 26.6758C32.3338 27.0669 32.75 27.7887 32.75 28.5693C32.7498 29.7774 31.7706 30.7567 30.5625 30.7568H13.4375C12.2294 30.7567 11.2502 29.7774 11.25 28.5693C11.25 27.8375 11.6155 27.1574 12.2178 26.7529L12.3418 26.6758L12.876 26.3662L13.25 26.1494V19.0068C13.25 14.1743 17.1675 10.2568 22 10.2568Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHeaderNoAlert);
export default __webpack_public_path__ + "static/media/btn_header_no_alert.d5146b5c35c1b2818f002af23dbd46b8.svg";
export { ForwardRef as ReactComponent };